"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectSpace = void 0;
const vue_1 = require("vue");
const ConfirmDialog_1 = require("./common/ConfirmDialog");
const PreferencesManager_1 = require("./PreferencesManager");
const TranslateMixin_1 = require("./TranslateMixin");
const TileType_1 = require("../TileType");
exports.SelectSpace = vue_1.default.component('select-space', {
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            availableSpaces: new Set(this.playerinput.availableSpaces),
            selectedTile: undefined,
            spaceId: undefined,
            warning: undefined,
            tileType: this.playerinput.tileType,
        };
    },
    components: {
        'confirm-dialog': ConfirmDialog_1.ConfirmDialog,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        animateSpace: function (tile, activate) {
            if (activate) {
                tile.classList.add('board-space--available');
            }
            else {
                tile.classList.remove('board-space--available');
            }
        },
        animateAvailableSpaces: function (tiles) {
            tiles.forEach((tile) => {
                const spaceId = tile.getAttribute('data_space_id');
                if (spaceId !== null && this.availableSpaces.has(spaceId)) {
                    this.animateSpace(tile, true);
                }
            });
        },
        cancelPlacement: function () {
            if (this.selectedTile === undefined) {
                throw new Error('unexpected, no tile selected!');
            }
            this.animateSpace(this.selectedTile, false);
            this.animateAvailableSpaces(this.getSelectableSpaces());
        },
        confirmPlacement: function () {
            const tiles = this.getSelectableSpaces();
            tiles.forEach((tile) => {
                tile.onclick = null;
            });
            if (this.selectedTile === undefined) {
                throw new Error('unexpected, no tile selected!');
            }
            this.$data.spaceId = this.selectedTile.getAttribute('data_space_id');
            this.selectedTile.classList.add('board-space--selected');
            this.saveData();
        },
        disableAvailableSpaceAnimation: function () {
            const tiles = this.getSelectableSpaces();
            tiles.forEach((tile) => {
                tile.classList.remove('board-space--available', 'board-space--selected');
            });
        },
        getSelectableSpaces: function () {
            const spaces = [];
            const regions = ['main_board', 'moon_board', 'colony_spaces'];
            for (const region of regions) {
                const board = document.getElementById(region);
                if (board !== null) {
                    const array = board.getElementsByClassName('board-space-selectable');
                    for (let i = 0, length = array.length; i < length; i++) {
                        spaces.push(array[i]);
                    }
                }
            }
            return spaces;
        },
        hideDialog: function (hide) {
            PreferencesManager_1.PreferencesManager.save('show_tile_confirmation', !hide);
        },
        onTileSelected: function (tile) {
            this.selectedTile = tile;
            this.disableAvailableSpaceAnimation();
            this.animateSpace(tile, true);
            tile.classList.remove('board-space--available');
            const displayTileConfirmation = PreferencesManager_1.PreferencesManager.load('show_tile_confirmation') === '0';
            if (displayTileConfirmation) {
                this.confirmPlacement();
            }
            else {
                this.$refs['confirmation'].show();
            }
        },
        saveData: function () {
            if (this.$data.spaceId === undefined) {
                this.$data.warning = 'Must select a space';
                return;
            }
            const soundsEnabled = PreferencesManager_1.PreferencesManager.load('enable_tile_placement_sounds') === '1';
            if (soundsEnabled) {
                let path;
                switch (this.tileType) {
                    case undefined:
                        break;
                    case TileType_1.TileType.CITY:
                        path = "../../../assets/sounds/construction.wav";
                        break;
                    case TileType_1.TileType.GREENERY:
                        path = "../../../assets/sounds/leaves.wav";
                        break;
                    case TileType_1.TileType.OCEAN:
                        path = "../../../assets/sounds/splash.wav";
                        break;
                    case TileType_1.TileType.MINING_AREA:
                    case TileType_1.TileType.MINING_RIGHTS:
                    case TileType_1.TileType.MINING_STEEL_BONUS:
                    case TileType_1.TileType.MINING_TITANIUM_BONUS:
                    case TileType_1.TileType.MOON_COLONY:
                    case TileType_1.TileType.MOON_MINE:
                    case TileType_1.TileType.MOON_ROAD:
                        path = "../../../assets/sounds/hammer.wav";
                        break;
                    case TileType_1.TileType.NUCLEAR_ZONE:
                        path = "../../../assets/sounds/explosion.wav";
                        break;
                    case TileType_1.TileType.LAVA_FLOWS:
                        path = "../../../assets/sounds/lava.wav";
                        break;
                    case TileType_1.TileType.ECOLOGICAL_ZONE:
                        path = "../../../assets/sounds/wildlife.wav";
                        break;
                    case TileType_1.TileType.CATHEDRAL:
                        path = "../../../assets/sounds/temple.wav";
                        break;
                    default:
                        path = "../../../assets/sounds/thud.wav";
                        break;
                }
                if (path !== undefined) {
                    const audio = new Audio(path);
                    audio.play();
                }
            }
            this.onsave([[this.$data.spaceId]]);
        },
    },
    mounted: function () {
        this.disableAvailableSpaceAnimation();
        const tiles = this.getSelectableSpaces();
        this.animateAvailableSpaces(tiles);
        for (let i = 0, length = tiles.length; i < length; i++) {
            const tile = tiles[i];
            const spaceId = tile.getAttribute('data_space_id');
            if (spaceId === null || this.availableSpaces.has(spaceId) === false) {
                continue;
            }
            ;
            tile.onclick = () => this.onTileSelected(tile);
        }
    },
    template: `<div>
    <confirm-dialog
        class="dialog"
        message="Place your tile here?\n(This confirmation can be disabled in preferences)."
        :enableDontShowAgainCheckbox="true"
        ref="confirmation"
        v-on:accept="confirmPlacement"
        v-on:dismiss="cancelPlacement"
        v-on:hide="hideDialog" />
    <div v-if="showtitle" class="wf-select-space">{{ $t(playerinput.title) }}</div>
    <div v-if="warning" class="nes-container is-rounded"><span class="nes-text is-warning">{{ warning }}</span></div>
  </div>`,
});
//# sourceMappingURL=SelectSpace.js.map